import React from "react";
import { useLocation } from "react-router-dom";
import "./EventAttendanceError.css";
import { getBrandLogo, getBrandLogoAlt } from "../../../utils/brandLogo";

const EventAttendanceError = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const errorMessage = query.get("error_message") || "An error occurred while processing your request.";

    return (
        <div className="error-wrapper">
            <div className="error-card">
                <img src={getBrandLogo()} alt={getBrandLogoAlt()} className="error-logo" />
                <h1 className="error-title">🚫 Attendance Could Not Be Recorded</h1>
                <p className="error-message">{errorMessage}</p>
                <p className="error-subtext">
                    Something went wrong while processing your response. Please try again later or reach out to the event organizer for assistance.
                </p>
            </div>
        </div>
    );
};

export default EventAttendanceError;
